import { render } from "./Plc.vue?vue&type=template&id=6c9f2b23"
import script from "./Plc.vue?vue&type=script&lang=js"
export * from "./Plc.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__